<template>
    <div v-if="local_plan_entrainement.propose">
        <div class="spo-card rounded bordered p-1 my-2">
            <div class="text-h6">{{ local_plan_entrainement.titre }}</div>
            <div>
                <v-checkbox color="primary-dark" hide-details @change="onChange"
                    :label="checkbox_label" v-model="local_plan_entrainement.selected">
                </v-checkbox>
                <div class="text-body mt-2 plan-entrainement-description" v-if="local_plan_entrainement.description">
                    {{ local_plan_entrainement.description }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["plan_entrainement", "commande_inscription"],
    data() {
        return {
            local_plan_entrainement: {}
        };
    },
    computed: {
        checkbox_label() {
            return "Souscrire au " + this.local_plan_entrainement.titre + " pour " + this.local_plan_entrainement.prix + "€";
        },
    },
    mounted() {
        this.local_plan_entrainement = this.plan_entrainement;
    },
    methods: {
        onChange() {
            Object.assign(this.plan_entrainement, { selected: this.local_plan_entrainement.selected });
            this.$emit("updatePlanEntrainement");
        }
    }
};
</script>

<style lang="scss" scoped>
.plan-entrainement-description {
    white-space: pre-line;
}
</style>
